import {createApp} from "vue";
import App from "@/vue/ProjectMap/ProjectMap.vue";
import  VueGoogleMaps from '@fawmi/vue-google-maps'

// App main
const main = async () => {
    // Async load the vue module
    const app = createApp(App)
    app.use(VueGoogleMaps, {
        load: {
            key: 'AIzaSyCOwZZ2S_hYlyWpPKXoFDF1U3YsmeZEqLw',
        },
    });
    app.mount('#project-map-app')
};

// Execute async function
main().then(() => {
    console.log('Loaded project map');
});
//
//
// (() => {
//     function init() {
//         Alpine.store('projectmap', {
//             on: false,
//
//             toggle() {
//                 this.on = ! this.on
//             }
//         })
//
//         console.log('Google maps loaded: ', googleMaps);
//         const mapData = window.mapData;
//         const map = googleMaps.getMap('project-map');
//         const {locations} = mapData
//
//         locations.forEach(function(location) {
//             map.markers(location.projectLocation)
//         });
//     }
//     document.addEventListener('alpine:init', init)
// })();


// Accept HMR as per: https://vitejs.dev/guide/api-hmr.html
if (import.meta.hot) {
    import.meta.hot.accept(() => {
        console.log("HMR")
    });
}